<!-- TODO: can we hide close button on showConfirmDeletion? Or does the close button need to be pulled into here? -->
<button class="icon-delete-button" *ngIf="!showConfirmDeletion" (click)="deleteImageIntent()">
  <svg-icon class="icon-delete" src="assets/icons/trash.svg"></svg-icon>
</button>
<kp-carousel class="image-carousel" [options]="sliderOptions" [plugins]="[MutationPlugin, ResizePlugin]">
  <div class="carousel-image-wrap" *ngFor="let image of images">
    <img
      class="carousel-image"
      [src]="image?.url"
      [alt]="'Uploaded image, original filename was ' + image?.originalFilename" />
  </div>
</kp-carousel>
<kp-bottom-arrow-nav
  class="bottom-nav"
  *ngIf="!showConfirmDeletion"
  [showsBackButton]="showNavButtons"
  (backClick)="slider?.prev?.()"
  [showsNextButton]="showNavButtons"
  (nextClick)="slider?.next?.()"
  [showsContent]="true"
  [showFade]="false">
  <a routerLink="/me/photos" class="link-view-all" (click)="checkCurrentPage($event)">View All</a>
</kp-bottom-arrow-nav>

<div *ngIf="showConfirmDeletion" class="confirm-deletion-popup">
  <p class="confirm-remove-question">Are you sure you want to remove this image from {{ product }}?</p>
  <div class="delete-confirmation-buttons">
    <button class="button-delete-cancel" (click)="deleteImage(false)" [disabled]="deletingImage">Cancel</button>
    <button
      class="button button-pill button-reverse button-w-icon button-delete-confirm"
      (click)="deleteImage(true)"
      [disabled]="deletingImage">
      <svg-icon src="assets/icons/trash.svg" class="button-icon"></svg-icon>
      <span>Remove</span>
    </button>
  </div>
</div>
